import { createIcon } from '../createIcon';
import { ReactComponent as IconMinus } from '../svg/minus.svg';

export default createIcon(IconMinus);
